import * as Yup from 'yup'
import {BaseEntity} from '../../../../shared/models/ApiModels'

/** location tablosu */
export interface ILocationModel extends BaseEntity {
  province: string
  district: string
}

export const validationLocation = Yup.object().shape({
  province: Yup.string()
    .trim()
    .required('İl zorunludur')
    .max(255, 'İl en fazla 255 karakter olabilir'),
  district: Yup.string()
    .trim()
    .required('İlçe zorunludur')
    .max(255, 'İlçe en fazla 255 karakter olabilir'),
})

export const initialLocation: ILocationModel = {
  id: '',
  province: '',
  district: '',
}
